var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLogoutMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 129,
    viewBox: "0 0 130 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_26758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 129C100.899 129 130 100.122 130 64.5C130 28.8776 100.899 0 65 0C29.1015 0 0 28.8776 0 64.5C0 100.122 29.1015 129 65 129Z",
    fill: "url(#paint0_linear_1598_26758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 85.9996C61.0081 85.9996 57.7779 82.7907 57.7779 78.8331V75.4508C57.7779 67.1311 62.3975 59.633 69.5422 56.3478C73.5059 54.5246 77.0464 49.7602 75.4455 43.604C74.5286 40.095 71.5381 37.1275 68.0048 36.2202C64.5346 35.3306 61.1 35.9821 58.3774 38.0759C55.7043 40.1318 54.1669 43.2331 54.1669 46.5828C54.1669 50.5405 50.9367 53.7494 46.9448 53.7494C42.9529 53.7494 39.7227 50.5405 39.7227 46.5828C39.7227 38.7662 43.2984 31.5357 49.5333 26.745C55.7751 21.9473 63.8227 20.3482 71.6161 22.3429C80.2136 24.5475 87.2031 31.484 89.4248 40.0164C92.528 51.9141 86.7164 64.252 75.608 69.3541C73.5838 70.2848 72.2227 72.7353 72.2227 75.4508V78.8331C72.2222 82.7907 68.992 85.9996 65 85.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9995 107.5C68.9881 107.5 72.2216 104.292 72.2216 100.334C72.2216 96.3756 68.9881 93.167 64.9995 93.167C61.0108 93.167 57.7773 96.3756 57.7773 100.334C57.7773 104.292 61.0108 107.5 64.9995 107.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1598_26758",
    x1: 7.70757e-7,
    y1: 55.9,
    x2: 130.001,
    y2: 55.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DAB45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191026,
    stopColor: "#1B973F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114526"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_26758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 129,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMark);
export default __webpack_public_path__ + "static/media/logout-mark.ab1d2acc579f75f3e94cb11b76b475b0.svg";
export { ForwardRef as ReactComponent };